module.exports = __webpack_public_path__ + "img/rule20.png";